// All comments in English.
import { http } from "@/core/http";

export interface ProductOption {
  product: string;
  seat_band_thresholds: Record<string, unknown>;
}

/** Load product options from backend. */
export async function getProducts(params?: { includeSeatBands?: boolean }) {
  const { data } = await http.get<ProductOption[]>(
    "/autodesk_usage/meta/products",
    { params: { includeSeatBands: params?.includeSeatBands ?? true } }
  );
  return data;
}
